// extracted by mini-css-extract-plugin
export var background = "featurePageHeader-module--background--fde09";
export var container = "featurePageHeader-module--container--1cfe8";
export var desktopImage = "featurePageHeader-module--desktopImage--c1c84";
export var featurePageContent = "featurePageHeader-module--featurePageContent--25113";
export var featurePageImageContainer = "featurePageHeader-module--featurePageImageContainer--acd0f";
export var headline = "featurePageHeader-module--headline--56f56";
export var mobileImage = "featurePageHeader-module--mobileImage--0181b";
export var subheading = "featurePageHeader-module--subheading--8c319";